import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";

import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";
import * as actions from "../../../../../actions/project.actions";

import PotentialMatchesTable from "../components/AdminProjectMatchesTable";
import rejectProjectModal from "../../common/components/rejectProjectModal";

import { formatDateMedium } from "../../../../../utils/dates";
import parseAdvancedSearch from "../../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../../utils/parseQueries";

const header = (
  rejectProjectModal,
  rejectProject,
  approveProject,
  submitDate,
  submitName
) => ({
  color: "strongGrey",
  title: "Pending Approval",
  text: `This project was submitted on ${formatDateMedium(
    submitDate
  )} by ${submitName}.
    It must be approved before it can be matched to Members.`,
  buttons: [
    {
      text: "Reject",
      type: "modalTrigger",
      modal: rejectProjectModal,
      modalClick: rejectProject,
      modalProps: {
        userName: submitName
      }
    },
    {
      text: "Approve & Notify",
      color: "blue",
      onClick: approveProject
    }
  ]
});

const rejectedHeader = () => ({
  color: "strongGrey",
  title: "Project successfully rejected"
});

const subHeader = (projectId, totalMatches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Potential Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/potential-matches`
      }
    ],
    activeItem: 1
  };
};

const approvedSubHeader = (projectId, totalMatches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: "Pitches",
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      }
    ],
    activeItem: 0
  };
};

class AdminProjecPotentialMatchesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      currentProjectState: null,
      filters: [],
      selection: []
    };

    this.getQuery = this.getQuery.bind(this);
    this.approveProject = this.approveProject.bind(this);
    this.rejectProject = this.rejectProject.bind(this);
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = this.getQuery();
    const projectId = this.props.match.params.projectId;

    this.props.adminActions.getProject(projectId);
    this.props.adminActions.getProjectMatches(projectId, filters);
    this.props.adminActions.getProjectMatchesCSVData(projectId, filters);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  setHeaderBar(prevState) {
    const project = this.props.project;
    const status = _.get(project, "status.name");

    const totalMatches = _.get(project, "stats.matches.potential");

    let headerBar = {};
    let selectedSubHeader = {};
    let currentProjectState = status;

    if (status != undefined) {
      switch (status) {
        case "draft":
        case "submitted-for-approval":
          headerBar = header(
            rejectProjectModal,
            this.rejectProject,
            this.approveProject,
            project.status_updated_at,
            `${project.user.first_name} ${project.user.first_name}`
          );
          selectedSubHeader = subHeader(project.id, totalMatches);
          break;

        case "rejected":
          selectedSubHeader = subHeader(project.id, totalMatches);
          headerBar = rejectedHeader();
          break;

        default:
          selectedSubHeader = approvedSubHeader(project.id, totalMatches);
          break;
      }
    }

    if (currentProjectState !== prevState.currentProjectState) {
      this.props.commonActions.setSubHeader(selectedSubHeader);
      this.props.commonActions.setHeaderBar(headerBar);
      this.setState({ currentProjectState });
    }
  }

  getQuery() {
    return getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch) +
        "&filter[potential]=1"
    );
  }

  approveProject() {
    const projectId = this.props.match.params.projectId;
    const selection = this.state.selection;

    const payload = {
      project_id: projectId,
      status_id: 4,
      notify: selection
    };

    this.props.adminActions.updateProject(
      payload,
      `matches${this.props.location.search}`
    );
  }

  rejectProject(messageValue) {
    const projectId = this.props.match.params.projectId;

    const payload = {
      project_id: projectId,
      status_id: 3,
      comments: messageValue
    };

    this.props.adminActions.updateProject(payload);
  }

  onUpdateSelection = value => {
    this.setState({
      selection: value
    });
  };

  onUpdateFilters = value => {
    this.setState({
      filters: value
    });
  };

  render() {
    return (
      !_.isEmpty(this.props.project) && (
        <PotentialMatchesTable
          project={this.props.project}
          matches={this.props.matches.data || []}
          matches_csv={_.get(this.props, "matches_csv.data") || []}
          advancedSearch={this.state.advancedSearch}
          filters={this.state.filters}
          getCsvData={this.props.adminActions.getProjectMatchesCSVData}
          getTable={this.props.adminActions.getProjectMatches}
          history={this.props.history}
          loading={this.props.loading}
          numberOfPages={this.props.matches.last_page}
          page={this.props.page}
          paginationCount={this.props.paginationCount}
          setPage={this.props.adminActions.setPage}
          setSort={this.props.adminActions.setSort}
          sortData={this.props.sortData}
          onUpdateFilters={this.onUpdateFilters}
          onUpdateSelection={this.onUpdateSelection}
        />
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.project.loadingGetProject,
    project: state.admin.project,
    matches: state.admin.matches,
    matches_csv: state.admin.matches_csv,
    page: state.admin.pagination.matches,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    sortData: state.admin.sorting.matches
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjecPotentialMatchesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/potentialMatches/containers/AdminProjectPotentialMatchesContainer.js